<template>
  <fullscreen-overlay-frame :title="title.toString()"
                            icon="control_point_duplicate"
                            :color="color"
                            centered
                            closable
                            @close="close">
    <template v-slot:content>
      <v-card :disabled="!data.gatewayAdded || !isSiteAdmin"
              class="mb-4"
              @click="addNukiBridge">
        <v-card-title class="pb-0">
          <v-icon class="material-icons-outlined" color="primary" left>key</v-icon>
          <span class="primary--text font-weight-bold font-size-04"
                v-text="$t('add-nuki-bridge-dialog.title')"/>
          <v-spacer/>
          <v-icon color="primary" class="material-icons-outlined">
            chevron_right
          </v-icon>
        </v-card-title>
        <v-card-text class="pl-12 font-size-02"
                     v-text="$t('add-smarthome-component-dialog.nuki-bridge.info')"/>
      </v-card>

      <v-card v-if="hasWilka"
              :disabled="!isSiteAdmin"
              class="mb-4"
              @click="addWilkaLock">
        <v-card-title class="pb-0">
          <v-icon class="material-icons-outlined" color="primary" left>key</v-icon>
          <span class="primary--text font-weight-bold font-size-04"
                v-text="$t('add-smarthome-component-dialog.wilka-lock.title')"/>
          <v-spacer/>
          <v-icon color="primary" class="material-icons-outlined">
            chevron_right
          </v-icon>
        </v-card-title>
        <v-card-text class="pl-12 font-size-02" v-text="$t('add-smarthome-component-dialog.wilka-lock.info')"/>
      </v-card>

      <v-card v-if="hasKaadas"
              :disabled="!data.gatewayAdded || !isSiteAdmin"
              class="mb-4"
              @click="addDevice(true)">
        <v-card-title class="pb-0">
          <span class="material-symbols-outlined v-icon primary--text">door_sensor</span>
          <span class="primary--text font-weight-bold font-size-04"
                v-text="$t('device-type-selection-dialog.add-secure-zwave-device')"/>
          <v-spacer/>
          <v-icon color="primary" class="material-icons-outlined">
            chevron_right
          </v-icon>
        </v-card-title>
        <v-card-text class="pl-12 font-size-02"
                     v-text="$t('device-type-selection-dialog.add-secure-zwave-device.info')"/>
      </v-card>

      <v-card :disabled="!data.gatewayAdded || !isSiteAdmin"
              class="mb-4"
              @click="addDevice(false)">
        <v-card-title class="pb-0">
          <v-icon class="material-icons-outlined" color="primary" left>widgets</v-icon>
          <span class="primary--text font-weight-bold font-size-04"
                v-text="$t('device-type-selection-dialog.add-zwave-device')"/>
          <v-spacer/>
          <v-icon color="primary" class="material-icons-outlined">
            chevron_right
          </v-icon>
        </v-card-title>
        <v-card-text class="pl-12 font-size-02"
                     v-text="$t('add-smarthome-component-dialog.device.info')"/>
      </v-card>
    </template>
  </fullscreen-overlay-frame>
</template>


<script>
import config from "@/config/config.app.json";
import FullscreenOverlayFrame from "@/templates/dialogs/FullscreenOverlayFrame";

export default {
  name: 'DeviceTypeSelectionDialog',
  components: {
    FullscreenOverlayFrame
  },

  props: ['data'],

  data: function () {
    return {
      title: this.$t('add-smarthome-component-dialog.title'),
      color: 'primary'
    }
  },

  computed: {
    isSiteAdmin() {
      return this.$rhAuth.isSiteAdmin()
    },
    hasWilka() {
      return (/true/).test(config.hasWilka)
    },
    hasKaadas() {
      return (/true/).test(config.hasKaadas)
    },
  },

  methods: {
    /**
     * open add device dialog
     */
    addDevice(secure) {
      this.close()
      this.$root.bisadialog.toggle('addDevice', true, {secure: secure})
      this.$root.bisadialog.callDialogInit('addDevice')
    },

    /**
     * open add nuki bridge dialog
     */
    addNukiBridge() {
      this.close()
      this.$root.bisadialog.toggle('addNukiBridge', true, {})
      this.$root.bisadialog.callDialogInit('addNukiBridge')
    },

    addWilkaLock() {
      this.close()
      this.$root.bisadialog.toggle('addWilkaLock', true, {})
      this.$root.bisadialog.callDialogInit('addWilkaLock')
    },

    /**
     * close dialog
     */
    close() {
      this.$root.bisadialog.toggle('deviceTypeSelection')
    }
  }
};
</script>


